import React from 'react'
import styled from 'styled-components'
import bg from 'img/bg.jpg'
import logo from 'img/logo.svg'
import tg from 'img/tg.svg'
import medium from 'img/medium.svg'
import {
  ANNOUNCEMENT_LINK,
  CHAKRA_LINK,
  MEDIUM_LINK,
  REGISTRATION_LINK,
  TG_LINK,
} from 'configs/app.config'

export default function Main() {
  return (
    <Root>
      <Bg src={bg} alt="bg" />
      <Container>
        <Logo src={logo} alt="logo" />
        <Text>
          Occam is no longer operational.
          <br />
          The official announcement can be found{' '}
          <a href={ANNOUNCEMENT_LINK} target={'_blank'}>
            here
          </a>
          <span>
            InterSwap IDO refund{' '}
            <a href={REGISTRATION_LINK} target={'_blank'}>
              registration
            </a>
            <br />
            Chakra rewards{' '}
            <a href={CHAKRA_LINK} target={'_blank'}>
              registration
            </a>
          </span>
        </Text>
        <Row>
          <Socials>
            <SocialItem href={TG_LINK} target="_blank">
              <img src={tg} alt={'socials'} />
              <span>Telegram</span>
            </SocialItem>
            <SocialItem href={MEDIUM_LINK} target="_blank">
              <img src={medium} alt={'socials'} />
              <span>Medium</span>
            </SocialItem>
          </Socials>
          <Copyright>© 2020-2026 Occam Inc.</Copyright>
        </Row>
      </Container>
    </Root>
  )
}

const Root = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  padding: 2.6vw;
  font-family: 'NeueHaasDisplay';
  overflow: hidden;
  ${({ theme }) => theme.adaptive.sm} {
    padding: 6.25vw;
  }
`

const Bg = styled.img`
  position: absolute;
  display: block;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: left top;
`

const Container = styled.div`
  position: relative;
  width: 62.5vw;
  height: 100%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  ${({ theme }) => theme.adaptive.sm} {
    width: 87.5vw;
  }
`

const Logo = styled.img`
  display: block;
  width: 9.32vw;
  ${({ theme }) => theme.adaptive.sm} {
    width: 55.93vw;
  }
`

const Text = styled.p`
  position: relative;
  color: #27303b;
  font-size: 2.08vw;
  font-weight: 200;
  line-height: 125%;
  letter-spacing: -0.02vw;
  ${({ theme }) => theme.adaptive.sm} {
    width: 100%;
    font-size: 7.5vw;
    letter-spacing: -0.075vw;
  }
  span {
    display: block;
    margin-top: 3.125vw;
    ${({ theme }) => theme.adaptive.sm} {
      margin-top: 12.5vw;
    }
  }
  a {
    position: relative;
    cursor: pointer;
    transition: 0.4s;
    user-select: none;
    outline: none;
    color: #27303b;
    &:after {
      content: '';
      position: absolute;
      left: 0;
      bottom: -5px;
      width: 100%;
      height: 2px;
      background: #27303b;
      ${({ theme }) => theme.adaptive.sm} {
        height: 1px;
        bottom: -3px;
      }
    }
    &:hover {
      &:after {
        opacity: 0;
      }
    }
  }
`

const Row = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  ${({ theme }) => theme.adaptive.sm} {
    flex-wrap: wrap;
    justify-content: center;
    gap: 6.25vw;
  }
`

const Copyright = styled.p`
  color: #939baa;
  text-align: right;
  font-size: 0.9375vw;
  font-weight: 400;
  letter-spacing: -0.009375px;
  margin: 0;
  ${({ theme }) => theme.adaptive.sm} {
    font-size: 5vw;
    letter-spacing: -0.05vw;
    width: 100%;
    text-align: center;
  }
`

const Socials = styled.div`
  display: flex;
  gap: 2.7vw;
  ${({ theme }) => theme.adaptive.sm} {
    justify-content: center;
    gap: 16.25vw;
  }
`

const SocialItem = styled.a`
  display: flex;
  gap: 0.3125vw;
  align-items: center;
  height: 1.09vw;
  ${({ theme }) => theme.adaptive.sm} {
    gap: 1.875vw;
    height: 6.56vw;
  }
  span {
    display: block;
    color: #939baa;
    font-size: 0.9375vw;
    font-weight: 400;
    letter-spacing: -0.009375vw;
    line-height: normal;
    ${({ theme }) => theme.adaptive.sm} {
      font-size: 5vw;
      letter-spacing: -0.05vw;
    }
  }
  &:nth-child(1) {
    img {
      display: block;
      width: 0.9375vw;
      ${({ theme }) => theme.adaptive.sm} {
        width: 5.625vw;
      }
    }
  }
  &:nth-child(2) {
    img {
      display: block;
      width: 0.833vw;
      margin-top: -0.05vw;
      ${({ theme }) => theme.adaptive.sm} {
        width: 5vw;
        margin-top: -0.3125vw;
      }
    }
  }
`
